/**
 * DividerRenderer — divider
 * Visual horizontal separator; optional label in the center.
 */
import React from "react";
import { AnimatedField } from "../../animations/AnimatedField";
import { resolveTextOptional } from "../../utils/resolveText";

/* eslint-disable react/prop-types */

export function DividerRenderer({ element, playing, isPaused, currentTimeSec }) {
  const label = element.label ? resolveTextOptional(element.label) : null;
  const labelField = element.label;
  const boxAnimation =
    (typeof labelField === "object" && labelField?.boxAnimation) ?? element.boxAnimation ?? null;
  const boxExitAnimation =
    (typeof labelField === "object" && labelField?.boxExitAnimation) ??
    element.boxExitAnimation ??
    null;

  if (label) {
    return (
      <AnimatedField
        boxAnimation={boxAnimation}
        boxExitAnimation={boxExitAnimation}
        playing={playing}
        isPaused={isPaused}
        currentTimeSec={currentTimeSec}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--space-3)",
            minHeight: "40px",
            width: "100%",
          }}
        >
          <div
            style={{ flex: 1, height: "var(--stroke-thin)", background: "var(--color-divider)" }}
          />
          <span
            style={{
              fontFamily: "var(--font-body)",
              fontSize: "var(--text-sm)",
              color: "var(--color-text-muted)",
              letterSpacing: "0.06em",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </span>
          <div
            style={{ flex: 1, height: "var(--stroke-thin)", background: "var(--color-divider)" }}
          />
        </div>
      </AnimatedField>
    );
  }

  return (
    <AnimatedField
      boxAnimation={boxAnimation}
      boxExitAnimation={boxExitAnimation}
      playing={playing}
      isPaused={isPaused}
      currentTimeSec={currentTimeSec}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          minHeight: "40px",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "var(--stroke-thin)",
            background: "var(--color-divider)",
            borderRadius: "var(--radius-full)",
          }}
        />
      </div>
    </AnimatedField>
  );
}

export default DividerRenderer;
